

















































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { AgencyModel, IAgency, IRole, IUser, UserSpecialType } from 'admiral-core';
import { CalendarIcon, CircleIcon, DiscIcon, PlusIcon, XIcon } from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { FormMixin } from '@/mixins/FormMixin';
import AgencyForm from '@/forms/AgencyForm.vue';
import { AgencyApi } from '@/services/AgencyApi';
import { BModal, BvModalEvent } from 'bootstrap-vue';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import Avatar from '@/components/common/Avatar.vue';
import UserStatusBadge from '@/components/common/UserStatusBadge.vue';
import { Util } from '@/utils/Util';
import EditUserModal from '@/views/pages/settings/agency/EditUserModal.vue';
import { UserApi } from '@/services/UserApi';
import CreateUserModal from '@/views/pages/settings/agency/CreateUserModal.vue';

@Component({
  components: {
    CreateUserModal,
    EditUserModal,
    UserStatusBadge,
    Avatar,
    FormSubmit,
    AgencyForm,
    CircleIcon,
    DiscIcon,
    CalendarIcon,
    XIcon,
    PlusIcon,
  },
})
export default class EditAgencyModal extends mixins(BaseMixin, FormMixin) {
  @Prop({ required: true, type: Object })
  selectedAgency!: IAgency;

  selectedUser?: Partial<IUser> = {};

  model = this.defaultModel();

  defaultModel(): AgencyModel {
    return {
      ...this.selectedAgency,
      notes: this.selectedAgency.notes || '',
    };
  }

  @Watch('selectedAgency')
  watchSelectedAgency() {
    this.model = {
      ...this.selectedAgency,
      notes: this.selectedAgency.notes || '',
    };
  }

  async mounted() {
    this.$root.$on('bv::modal::hide', async (bvEvent: BvModalEvent, modalId: string) => {
      if (modalId === 'edit-agency' && bvEvent.trigger === 'esc') {
        await this.cancel();
      }
    });
  }

  async destroyed() {
    this.$root.$off('bv::modal::hide');
  }

  async ok(evt: Event) {
    evt.preventDefault();
    try {
      this.isLoading = true;

      await AgencyApi.update(this.model.id!, {
        name: this.model.name!,
        status: this.model.status!,
        plan: this.model.plan!,
        type: this.model.type!,
        endsAt: this.model.endsAt!,
        identifier: this.model.identifier!,
        notes: this.model.notes!,
        startedAt: this.model.startedAt!,
        moduleAntragsbuch: this.model.moduleAntragsbuch!,
        moduleGoals: this.model.moduleGoals!,
        moduleStatistics: this.model.moduleStatistics!,
      });

      this.model = { ...this.defaultModel() };
      this.$emit('reload');
      this.$toastr.s(`Agentur ${this.model.name} erfolgreich bearbeitet.`, 'Agentur bearbeitet');
      this.$nextTick(() => {
        (this.$refs['edit-agency'] as BModal).hide();
      });
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);

      this.errorHandling(apiErrors);
      this.$toastr.e('Beim Speichern der Agentur ist etwas schief gelaufen.', 'Oops');
      throw e;
    } finally {
      this.isLoading = false;
    }
  }

  errorHandling(apiErrors: Record<string, string>) {
    this.addError(apiErrors['nameisNotEmpty'], 'name', 'Bitte einen gültigen Namen eingeben.');

    this.addError(
      apiErrors['identifierisNotEmpty'],
      'identifier',
      'Bitte eine gültige ID eingeben',
    );

    this.addError(apiErrors['Existing'], 'identifier', 'Agentur existiert bereits');
  }

  async cancel() {
    this.model = { ...this.defaultModel() };
  }

  cancelDeletion() {
    //
  }

  async confirmDeletion() {
    try {
      await AgencyApi.delete(this.model.id!, { agency: this.model });

      (this.$refs['edit-agency'] as BModal).hide();
      this.$emit('reload');

      this.$toastr.s(`Agentur ${this.model.name} erfolgreich gelöscht.`, 'Agentur gelöscht');
    } catch (e) {
      this.$toastr.e('Beim Löschen der Agentur ist etwas schief gelaufen.');
      throw e;
    }
  }

  openEditModal(user: IUser) {
    this.selectedUser = user;
    // eslint-disable-next-line
    (this.$refs['edit-user-modal'] as any).$refs['edit-user'].show();
  }
  openCreateModal() {
    // eslint-disable-next-line
    (this.$refs['create-user-modal'] as any).$refs['create-user'].show();
  }
  roleLabel(role: IRole) {
    return Util.formatUserRoleName(role);
  }

  typeLabel(type: UserSpecialType) {
    return Util.formatUserSpecialType(type);
  }
  printGroup(group?: string) {
    return group ? `(${group})` : '';
  }
  async reload() {
    try {
      const response = await UserApi.getUsers({
        agency: this.model as IAgency,
      });
      this.model.users = [...response.data];
    } catch (e) {
      console.log(e);
    }
  }
}
